import React, { useEffect, useState } from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getbillsandPaymentsHistoryTab } from "../../../../bills-and-payments-hisrory-postpaid-prepaid/model/actions";
import { routePaths } from "../../../../config/route-paths";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../../../../helpers";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import E_LASTRECHARGE from "./_last_recharge";

const useStyle = makeStyles((theme) => ({
  lightLine: {
    backgroundColor: theme.palette.eSecondary?.base,
    padding: "1% 8% !important",
    color: theme.palette.eWhite?.base,
    marginBottom: "4% !important",
    display: "inline-flex",
  },
  viewButton: {
    borderRadius: "20px",
    color: theme.palette.eWhite?.base,
    background: theme.palette.eTertiary?.base,
    textTransform: "capitalize",
    "&:hover": {
      background: theme.palette.eTertiary?.hover,
    },
  },
  rechargeButton: {
    borderRadius: "20px",
    textTransform: "capitalize",
    color: theme.palette.eWhite?.base,
    backgroundColor: theme.palette.eSecondary?.base,
    "&:hover": {
      backgroundColor: theme.palette.eSecondary?.hover,
    },
  },
  marginTop: {
    marginTop: "0.5rem",
  },
}));
export default function E_Button() {
  let classes = useStyle();
  const dispatch = useDispatch();
  let meterDetails = useSelector((store) => store?.meterDetails);
  const { t: labels, ready: labelReady } = useTranslation(
    "label-E_PREPAID_ACCOUNTSUMMARY"
  );
  let [recharge, setRecharge] = useState();
  const { t: content } = useTranslation("content-E_PREPAID_ACCOUNTSUMMARY");
  const EDGE_CURRENCY_SYMBOL = "BDT";
  const [currencySymbol, setCurrencySymbol] = useState("");
  let currencyCode = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  );
  useEffect(() => {
    if (meterDetails?.curSymbol) {
      setCurrencySymbol(
        meterDetails?.curSymbol &&
          meterDetails?.curSymbol == EDGE_CURRENCY_SYMBOL
          ? currencyCode
          : meterDetails?.curSymbol
      );
    }
  }, [meterDetails?.curSymbol]);
  useEffect(() => {
    if (
      meterDetails?.getSaInfo?.prepaidSaDetail?.amountToRchg &&
      meterDetails?.getSaInfo?.prepaidSaDetail?.nextRchgDueDate
    ) {
      setRecharge();
    }
  }, [meterDetails]);
  let dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.SHORT_DATE_FORMAT
  );
  const chargesOnClick = () => {
    dispatch(getbillsandPaymentsHistoryTab(0));
    history.push(routePaths.BILLING);
  };
  const rechargeOnClick = () => {
    dispatch(getbillsandPaymentsHistoryTab(1));
    history.push(routePaths.INITIATE_PAYMENT);
  };
  const Numberwithcommas = (x) => {
    x = x.toString();
    let reqNumber = x.split(".");
    return (
      reqNumber[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,") +
      (reqNumber[1] ? "." + reqNumber[1] : "")
    );
  };
  return (
    <Grid container spacing={0} justify="center" alignContent="center">
      <Grid item xs={12} className={classes.marginTop}>
        <Grid container justify="center" spacing={2}>
          <Grid item>
            <Button
              variant="outlined"
              className={classes.viewButton}
              onClick={chargesOnClick}
            >
              {labelReady ? labels("E_VIEW_CHARGES") : <Skeleton />}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              className={classes.rechargeButton}
              onClick={rechargeOnClick}
            >
              {labelReady ? labels("E_RECHARGE") : <Skeleton />}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
